import { ReactComponent as ApprovalIcon } from '@Icons/menu/approval.svg';
import BaseNameSideItem from '@Enum/BaseNameSideMenuItem.enum';
import { MenuItem } from '../../../types';
import { createItem } from '../../../utils/createItem';

const ApprovalsMenuItem: MenuItem = createItem(
  BaseNameSideItem.APPROVALS,
  BaseNameSideItem.APPROVALS,
  <ApprovalIcon />
);

export default ApprovalsMenuItem;
